import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '../loader/loader.service';
import { Observable, of, throwError, from, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ISearchForm } from '../_models/search';
import { environment } from '@environments/environment';
import { MCRVirtualFolder } from '../_models/mcrvirtualfolder';
import { MCRFolderElement } from '../_models/mcrfolderelement';
import { AlertService } from './alert.service';
import { AppConfig } from 'src/assets/config/config/app-config';

export interface IFolderService {
  add(fileElement: MCRFolderElement);
  queryInFolder(folderName: string): Observable<MCRFolderElement[]>;
  get(name: string): MCRFolderElement;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class McrfolderService implements IFolderService {

  private map = new Map<string, MCRFolderElement>();
  apiUrl:string

  constructor(
    private http: HttpClient,
    //private messageService: MessageService,
    private snackBar: MatSnackBar,
    private alertService: AlertService,
    private config:AppConfig
  ) {
    this.apiUrl=this.config.getConfig('apiUrl')
   }

  add(folderElement: MCRFolderElement) {
    //console.log("Folderlelement " + JSON.stringify(folderElement));
    if (folderElement.isFolder) {
      this.map.set(folderElement.path, this.clone(folderElement));
    } else {
      this.map.set(folderElement.documentId, this.clone(folderElement));
    }
    return folderElement;
  }

  get(name: string) {
    return this.map.get(name);
  }

  deleteRootElements() {
    this.map.forEach(element => {
      //if (element.parent === 'root') {
      if (element.isFolder) {
        this.map.delete(element.path);
      } else {
        this.map.delete(element.documentId);
      }
      //}
    });
  }

  deleteElementsByParent(parent) {
    this.map.forEach(element => {
      if (element.parent === parent) {
        console.log("Inside delete" + element.name + " " + element.path);
        if (element.isFolder) {
          this.map.delete(element.path);
        } else {
          this.map.delete(element.documentId);
        }
      }
    });
  }


  private querySubject: BehaviorSubject<MCRFolderElement[]>;
  queryInFolder(folderId: string) {
    const result: MCRFolderElement[] = [];
    this.map.forEach(element => {
      if (element.parent === folderId) {
        result.push(this.clone(element));
      }
    });
    if (!this.querySubject) {
      this.querySubject = new BehaviorSubject(result);
    } else {
      this.querySubject.next(result);
    }
    return this.querySubject.asObservable();
  }

  clone(element: MCRFolderElement) {
    return JSON.parse(JSON.stringify(element));
  }

  zLoader: number = 0;

  notify(message: string): void {
    this.snackBar.open(message, "", { duration: 5000 });
  }


  errorHandler(error: HttpErrorResponse) {
    return throwError(error)
  }


  getMCRFolders(req: any, offset: number): Observable<any> {
    //var response: new HttpResponse()
    //console.log("Req: " + JSON.stringify(req));
    return this.http.post<any>(this.apiUrl+`/virtual-folder/display?offset=` + offset + `&limit=1000`, req)
      .pipe(catchError(this.handleError<any>('getMCRFolders')));

  }

  private handleError<T>(operation = 'operation', result?: T) {
    //alert(JSON.stringify(err));  
    //o: T;
    //alert(typeof o);
    return (error: HttpErrorResponse): Observable<T> => {
      console.error('%s ' + error); // log to console instead
      console.error(
        `Backend returned code:  ${error.statusText}, ` +
        `body was: ${error.message}`);
      //this.snackBar.open(String(error).replace("error:", "ERROR:  "), "", { duration: 5000 });
      if (String(error).includes('.throw is not a function')) {
        this.alertService.error('ERROR: Could not connect to network. Please ensure that the Deloitte VPN is connected.');
      } else {
        this.alertService.error(String(error));
      }
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
      //return result;
    };
  }

}
